import React from 'react';

/**
 * Official Payo wordmark + icon. Use this instead of custom Send/Zap marks.
 *
 * Props:
 *  - size: 'sm' | 'md' | 'lg' (default 'md')
 *  - className: extra classes to merge
 *
 * Sizes render at the logo's natural aspect ratio (~3:1).
 */
const SIZE_HEIGHT = {
  sm: 'h-6',    // ~24px
  md: 'h-8',    // ~32px
  lg: 'h-10',   // ~40px
  xl: 'h-14',   // ~56px
};

const PayoLogo = ({ size = 'md', className = '', alt = 'Payo' }) => {
  const h = SIZE_HEIGHT[size] || SIZE_HEIGHT.md;
  return (
    <img
      src="/payo-logo.png"
      alt={alt}
      className={`${h} w-auto select-none ${className}`}
      draggable="false"
      data-testid="payo-logo"
    />
  );
};

export default PayoLogo;
